import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\Downloads\\esiptvpro.fr\\components\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\Administrator\\Downloads\\esiptvpro.fr\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\Administrator\\Downloads\\esiptvpro.fr\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\Administrator\\Downloads\\esiptvpro.fr\\node_modules\\next\\font\\google\\target.css?{\"path\":\"app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "C:\\Users\\Administrator\\Downloads\\esiptvpro.fr\\app\\globals.css");
